import {Component, OnInit} from '@angular/core';
import {ActivationEnd, Data, NavigationEnd, Router} from '@angular/router';
import {Meta} from '@angular/platform-browser';
import {AuthService} from '@services/auth.service';
import {CommonService} from '@services/common.service';
import {CanvasService} from '@services/canvas.service';
import {environment} from '@environments/environment';
import {SessionManagerService} from '@services/session/session-manager.service';
import {CookieService} from 'ngx-cookie-service';
import { AddTrackingService } from './services/add-tracking.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    title = 'Quantivate';

    constructor(
        public authService: AuthService,
        public canvasService: CanvasService,
        public commonService: CommonService,
        private meta: Meta,
        public router: Router,
        private sessionManagerService: SessionManagerService,
        private addTrackingService: AddTrackingService,
    ) {
        this.router.events.subscribe((event) => {
            if (event instanceof ActivationEnd) {
                const data: Data = event.snapshot.data;
                if (data?.isPreview) {
                    this.isPreview = data.isPreview;
                }
            }
        });
    }

    public isPreview = false;

    ngOnInit(): void {
        const buildName = sessionStorage.getItem('buildName') || '';
        this.meta.updateTag({name: 'buildName', content: buildName});

        this.authService.fetchUser()
        .then((data) => {
            this.sessionManagerService.init();
            this.getUserCategories();

            const userObject = JSON.parse(sessionStorage.getItem('userObject') || '{}');
            const productTrackingUrl = environment.productTrackingUrl;
            const quantivateProductId = environment.quantivateProductId;
            const ncUserId = userObject?.nc_user_id?.toString() || '';

            if (!ncUserId) {
            console.warn('[app.component] Skipping product tracking — nc_user_id missing.');
            //  do not call tracking service
            } else {
            this.addTrackingService.loadTrackingScript(productTrackingUrl, quantivateProductId, ncUserId);
            }
        });
    }

    getUserCategories(): void {
        this.commonService.getUserCategories()
        .subscribe((data: any) => {
            const userCategories = data.data;
            sessionStorage.setItem('userCategoryListing', JSON.stringify(userCategories));
        });
    }
}
